import React from 'react';
import { Flex, Skeleton, Text } from '@chakra-ui/react';
import { SectionHeader } from '../SectionHeader/sectionHeader';
import { IGame } from 'src/providers/Games/useGames';
import { Color } from 'src/theme/color';

export const TableHeader = ({
	header,
	headerStyle,
	headerRightText,
	loading,
	onClickRightHeader,
	isLoadMore,
	customTheme,
}: {
	onClickRightHeader: any;
	headerStyle: any;
	loading: boolean;
	isLoadMore: boolean;
	header: string;
	headerRightText: any;
	customTheme?: IGame['colors'];
}) => {
	return (
		<Flex
			fontSize="20px"
			alignItems="center"
			justifyContent="space-between"
			w="100%"
			userSelect="none"
		>
			<SectionHeader>{header}</SectionHeader>
			<Flex
				display={{ base: 'none', hashup: 'block' }}
				alignItems="center"
				justifyContent="center"
				height="20px"
				zIndex={5}
			>
				{isLoadMore ? (
					headerRightText && loading ? (
						<Skeleton
							color="#828282"
							opacity="0.1"
							borderRadius="4px"
							width="180px"
							h="100%"
						></Skeleton>
					) : (
						<Text
							cursor="pointer"
							fontSize="14px"
							color={customTheme?.textColor ?? Color.ACTION}
							onClick={onClickRightHeader}
						>
							{headerRightText}
						</Text>
					)
				) : (
					<></>
				)}
			</Flex>
		</Flex>
	);
};
